import { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="navbar">
      <div className="logo">
        <img src={`${process.env.PUBLIC_URL}/images/ELlogo.webp`} alt="Ejecta Landscapes logo" className="logo-img" width="1080" height="1080" decoding="async" />
        <span className="logo-text">Ejecta <span>Landscapes</span></span>
      </div>

      <button
        className={`nav-hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Toggle menu"
      >
        <span /><span /><span />
      </button>

      <nav className={menuOpen ? 'nav-open' : ''}>
        <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
        <NavLink to="/services" onClick={closeMenu}>Services</NavLink>
        <NavLink to="/my-works" onClick={closeMenu}>My Works</NavLink>
        <NavLink to="/contact" onClick={closeMenu}>Contact</NavLink>
      </nav>
    </header>
  );
}
